import { Component, OnInit, OnDestroy } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { CommonUtil } from '../../../core/Utils/common-util';
import { DashboardService } from '../../services/dashboard.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-stats-usage',
  templateUrl: './stats-usage.component.html',
  styleUrls: ['./stats-usage.component.css'],
})
export class StatsUsageComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  hasStats = false;
  statsData: any = {};
  cardioUsage:any;
  strengthUsage:any;
  currentFacility: FacilityObject;

  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    private rootScopeService: RootScopeService,
    private commonUtil: CommonUtil,
    private dashboardService: DashboardService,
    private _facilityService: FacilityService
  ) {}
  ngOnInit() {
    this.getRootScopeData();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
      this.setUpStatsUsageData();
    });

    if (this.currentFacility['facilityId']) {
      this.setUpStatsUsageData();
    }
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  redirectToStats() {
    location.href = 'halo.html#/stats';
  }

  setUpStatsUsageData() {
    if (
      this.currentFacility.summary.facilityRights.stats == 'true' &&
      this.currentFacility.summary.userRights.stats != 'H'
    )
      this.hasStats = true;

    let offset = new Date().getTimezoneOffset();

    this.statsData.facilityName = this.currentFacility.facilityName
      ? this.currentFacility.facilityName
      : this.currentFacility.ipAddress;

    let beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
    let beforeOneWeek2 = new Date(beforeOneWeek);
    let day = beforeOneWeek.getDay();
    let diffToSaturday = beforeOneWeek.getDate() - day;
    beforeOneWeek = new Date(beforeOneWeek.setDate(diffToSaturday));
    beforeOneWeek2 = new Date(beforeOneWeek2.setDate(diffToSaturday + 6));

    this.statsData.lastWeekStart = this.commonUtil.convertToLocalDateFormat(beforeOneWeek);
    this.statsData.lastWeekEnd = this.commonUtil.convertToLocalDateFormat(beforeOneWeek2);

    this.dashboardService.getStatsUsageData(this.currentFacility.facilityId, offset.toString()).subscribe(
      (data: any) => {
        this.cardioUsage = data;
      },
      (error: any) => {
        console.error('API failed.');
        this.cardioUsage = null;
      }
    );

    this.dashboardService.getStatsUsageDataLynx(this.currentFacility.facilityId).subscribe(
      (data: any) => {
        this.strengthUsage = data;
      },
      (error: any) => {
        console.error('API failed.');
        this.strengthUsage = null;
      }
    );
    
  }
}
